<rask-page
  pageTitle="Systemaktivitet"
  [actionShow]="canEdit()"
  [actionFn]="create"
  actionTitle="{{commonTexts.add}}">
  @for (systemaktivitet of systemaktivitetlista; track systemaktivitet) {
    <div>
      <rask-systemaktivitet-container [systemaktivitet]="systemaktivitet">
        <rask-action-button [disabled]="!canEdit()" (click)="delete(systemaktivitet)" icon="far fa-trash-alt" negative></rask-action-button>
        <rask-action-button [disabled]="!canEdit()" (click)="edit(systemaktivitet)" icon="far fa-pencil-alt" negative></rask-action-button>
      </rask-systemaktivitet-container>
    </div>
  }
</rask-page>